export const slaOptions = [
    { "label": "ACE / GO SPECIALIST", "value": "ACE / GO SPECIALIST" },
    { "label": "ASSISTANT GENERAL MANAGER", "value": "ASSISTANT GENERAL MANAGER" },
    { "label": "CARGO OPERATIONS PLANNER", "value": "CARGO OPERATIONS PLANNER" },
    { "label": "CARGO SOLUTIONS INVESTIGATOR", "value": "CARGO SOLUTIONS INVESTIGATOR" },
    { "label": "DANGEROUS GOODS SPECIALIST", "value": "DANGEROUS GOODS SPECIALIST" },
    { "label": "DOC RUNNERS", "value": "DOC RUNNERS" },
    { "label": "DOCK COORDINATOR", "value": "DOCK COORDINATOR" },
    { "label": "DUTY MANAGER", "value": "DUTY MANAGER" },
    { "label": "GENERAL MANAGER", "value": "GENERAL MANAGER" },
    { "label": "MAIL OPERATION PLANNER", "value": "MAIL OPERATION PLANNER" },
    { "label": "OJT COORDINATORS", "value": "OJT COORDINATORS" },
    { "label": "OPERATIONS MANAGER", "value": "OPERATIONS MANAGER" },
    { "label": "OTHER NOT DEFINED IN SLA", "value": "OTHER NOT DEFINED IN SLA" },
    { "label": "QUALIFIED “CERTIFIED” TRAINER", "value": "QUALIFIED “CERTIFIED” TRAINER" },
    { "label": "QUALITY ASSURANCE MANAGER", "value": "QUALITY ASSURANCE MANAGER" },
    { "label": "SAFETY, HEALTH, & COMPLIANCE MANAGER", "value": "SAFETY, HEALTH, & COMPLIANCE MANAGER" },
    { "label": "SECURITY SCREENER", "value": "SECURITY SCREENER" },
    { "label": "SPECIALTY PRODUCT COORDINATOR", "value": "SPECIALTY PRODUCT COORDINATOR" },
    { "label": "TRUCK COORDINATOR", "value": "TRUCK COORDINATOR" },
    { "label": "ULD COORDINATOR", "value": "ULD COORDINATOR" },
    { "label": "YARD OPERATIONS PLANNER", "value": "YARD OPERATIONS PLANNER" }
];

export const DEPARTMENTS = [
    'SAFETY',
    'GROUND',
    'CARGO',
    'HUMAN RESOURCES & TRAINING',
    'QUALITY & SAFETY',
    'EXECUTIVE',
    'IT',
    'MAINTENANCE',
    'TECHNOLOGY & INNOVATION',
    'TRAINING',
    'EXTERNAL'
];